import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MachineHistoryComponent } from './machine-history/machine-history.component';
import { Route } from '@angular/router';
import {
  GridV2Module,
  RadioV2Module,
  ButtonV2Module,
  InputV2Module,
  IconV2Module,
  DateV2Module,
  MultiselectV2Module,
  CheckboxV2Module,
  PagesV2Module,
  SpinnerV2Module,
  NotificationsV2Module,
  ModalModule,
} from '@schenck/rotec-components';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { MachineHistorySettingsApi } from '../machine-history/machine-history-settings.api';
import { MachineHistorySettingsService } from './machine-history-settings.service';
import {
  MachineHistorySearchService,
  MachineTaskSearchApi,
} from './machine-history-search.service';

import { MachineHistoryModalComponent } from './machine-history-modal/machine-history-modal.component';
import { FormsModule } from '@angular/forms';

export const machineHistoryRoutes: Route[] = [{ path: '', component: MachineHistoryComponent }];

@NgModule({
  imports: [
    CommonModule,
    TranslatePipe,
    TranslateDirective,
    FormsModule,
    GridV2Module,
    RadioV2Module,
    ButtonV2Module,
    InputV2Module,
    IconV2Module,
    DateV2Module,
    MultiselectV2Module,
    CheckboxV2Module,
    PagesV2Module,
    SpinnerV2Module,
    NotificationsV2Module,
    ModalModule,
    MachineHistoryComponent,
    MachineHistoryModalComponent,
  ],
  providers: [
    MachineHistorySettingsApi,
    MachineHistorySettingsService,
    MachineTaskSearchApi,
    MachineHistorySearchService,
  ],
})
export class MachineHistoryModule {}
